import { defineMessages } from 'react-intl';

import { fieldNames } from './model';

export const labels = defineMessages({
  [fieldNames.name]: {
    id: `graphql.UpdateBasicInfo.labels.name`,
    defaultMessage: 'Name',
  },
  [fieldNames.bio]: {
    id: `graphql.UpdateBasicInfo.labels.bio`,
    defaultMessage: 'Bio',
  },
  [fieldNames.img]: {
    id: `graphql.UpdateBasicInfo.labels.img`,
    defaultMessage: 'Choose an Avatar',
  },
  [fieldNames.position]: {
    id: `graphql.UpdateBasicInfo.labels.position`,
    defaultMessage: 'Position',
  },
  [fieldNames.yearsOfExperience]: {
    id: `graphql.UpdateBasicInfo.labels.yearsOfExperience`,
    defaultMessage: 'Years Of Experience',
  },
  [fieldNames.employmentStatus]: {
    id: `graphql.UpdateBasicInfo.labels.employmentStatus`,
    defaultMessage: 'Employment Status',
  },
  [fieldNames.country]: {
    id: 'graphql.UpdateBasicInfo.labels.country',
    defaultMessage: 'Country',
  },
});

export const header = defineMessages({
  title: {
    id: 'users.personal-details-form.header.title',
    defaultMessage: 'Personal Details',
  },
});

export const buttons = defineMessages({
  submit: {
    id: 'users.personal-details-form.buttons.submit',
    defaultMessage: 'Update Personal Details',
  },
});



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateBasicInfo/messages.js